import React, {useContext, useEffect, useState} from 'react';
import Drawer from 'components/Drawer';
import ProgramsTable from 'features/programs/ProgramsTable';
import ProgramsForm from 'features/programs/ProgramsForm';
import {TitleContext} from '../../components/TitleContext';

const ProgramsPage: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const openDrawer = () => setIsDrawerOpen(true);
  const closeDrawer = () => setIsDrawerOpen(false);
  const {setTitle} = useContext(TitleContext);

  useEffect(() => {
    setTitle(
      <div>
        <div className="text-slate-600 text-lg font-medium font-['Inter']  ">
          Programs
        </div>
        <div className="text-slate-400 text-sm font-light font-['Inter'] leading-normal ">
          Manage your company's programs
        </div>
      </div>,
    );
  }, [setTitle]);
  return (
    <div className="">
      <div className="relative overflow-hidden">
        <div className="relative">
          <ProgramsTable openDrawer={openDrawer} />
          <Drawer isOpen={isDrawerOpen} onClose={closeDrawer}>
            <ProgramsForm closeDrawer={closeDrawer} />
          </Drawer>
        </div>
      </div>
    </div>
  );
};

export default ProgramsPage;
